import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchStateData = createAsyncThunk("api/state", async () => {
  const response = await fetch(`${FULL_API_BASE_URL}/get-state/`);
  const data = await response.json();
  return data;
});

const stateSlice = createSlice({
  name: "domicileState",
  initialState: {
    statedata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateData.fulfilled, (state, action) => {
        state.loading = false;
        state.statedata = action.payload;
      })
      .addCase(fetchStateData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default stateSlice.reducer;

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// export const fetchStateData = createAsyncThunk("api/state", async () => {
//   const response = await fetch(
//     "http://3.110.178.2/coaching-collaborator-api/api/v1/get-state/"
//   );
//   const data = await response.json();
//   return data;
// });

// const stateSlice = createSlice({
//   name: "domicileState",
//   initialState: {
//     statedata: null,
//     loading: false,
//     error: null,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchStateData.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchStateData.fulfilled, (state, action) => {
//         state.loading = false;
//         state.statedata = action.payload;
//       })
//       .addCase(fetchStateData.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message;
//       });
//   },
// });

// export default stateSlice.reducer;
